import { render } from "./MonthSwitcher.vue?vue&type=template&id=03cb8e96&ts=true"
import script from "./MonthSwitcher.vue?vue&type=script&lang=ts"
export * from "./MonthSwitcher.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__